import React from "react";
import HeroSection from "../../Components/Sections/S1-Hero";
import AboutSection from "../../Components/Sections/S2-About";
import FeatureSection from "../../Components/Sections/S3-Features";
import TokenomicsSection from "../../Components/Sections/S5-Tokenomics";
import InTouchSection from "../../Components/Sections/S6-KeepInTouch";
import RoadmapSection from "../../Components/Sections/S4-Roadmap";


const MainPage = (props) => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <FeatureSection />
      <RoadmapSection />
      <TokenomicsSection />
      <InTouchSection />
    </>
  );
};

export default MainPage;
